// This file is used for maintain and manage API services.
(function() {
  'use strict';
  angular.module('obex').
  factory('customerAccount', ['$http', '$q', 'obexConstant', 'authService',
    ($http, $q, obexConstant, authService) => {
      return {
         getCustomerAccouts() {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlCustomerAccount}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
          },
        getCustomerAccoutsById(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlCustomerAccount}/${id}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        getCustomerAccountByOrgId(organizationId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlCustomerAccount}/organization/${organizationId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        //curd operation
        addCustomerAccount(customerAccount, orgId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const postData = {
              Id: 0,
              Name: customerAccount.Name,
              Number: customerAccount.Number,
              IsDefaultAccount: customerAccount.IsDefaultAccount,
              OrganizationId: orgId,
            };
            return $http.post(obexConstant.urlCustomerAccount, postData, {
              headers: authHeader,
            });
          });
        },
        updateCustomerAccount(id, customerAccount, orgId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlCustomerAccount}/${id}`;
            const putData = {
              Id: customerAccount.Id,
              Name: customerAccount.Name,
              Number: customerAccount.Number,
              IsDefaultAccount: customerAccount.IsDefaultAccount,
              OrganizationId: orgId,
            };
            return $http.put(url, putData, {
              headers: authHeader,
            });
          });
        },
        deleteCustomerAccount(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlCustomerAccount}/${id}`;
            return $http.delete(url, {
              headers: authHeader,
            });
          });
        },
      };
    },
  ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/customerAccount.service.js